import { motion } from "framer-motion";

export const StepBlock = ({ step, title, children, testId, delay = 0 }) => (
  <motion.section
    data-testid={testId}
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className="rounded-[28px] border border-navy/10 bg-white p-6 shadow-[0_30px_60px_-40px_rgba(11,21,48,0.45)] sm:p-9"
  >
    <p className="eyebrow text-gold-deep">{step}</p>
    <h2 className="mt-3 font-display text-3xl text-navy sm:text-4xl">{title}</h2>
    <div className="mt-7 space-y-5">{children}</div>
  </motion.section>
);

export const Field = ({ label, htmlFor, hint, error, children }) => (
  <div className="space-y-2">
    <label htmlFor={htmlFor} className="block text-sm font-medium text-navy">
      {label}
    </label>
    {children}
    {hint && <p className="text-xs leading-relaxed text-navy/55">{hint}</p>}
    {error && (
      <p className="text-xs text-red-700" data-testid={`${htmlFor}-error`}>
        {error}
      </p>
    )}
  </div>
);

export const inputCls =
  "h-12 w-full rounded-2xl border border-navy/15 bg-ivory/60 px-4 text-[15px] text-navy placeholder:text-navy/35 outline-none transition-[border-color,box-shadow] duration-300 focus:border-gold focus:ring-4 focus:ring-gold/15";

export const GoogleButton = ({ onClick, testId }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className="flex h-12 w-full items-center justify-center gap-3 rounded-2xl border border-navy/15 bg-white text-[15px] font-medium text-navy transition-[background-color,border-color] duration-300 hover:border-navy/30 hover:bg-ivory"
  >
    <svg viewBox="0 0 48 48" className="h-5 w-5">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
      <path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
      <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
    </svg>
    Continuer avec Google
  </button>
);

export const OrDivider = () => (
  <div className="flex items-center gap-4 text-xs uppercase tracking-[0.2em] text-navy/40">
    <span className="h-px flex-1 bg-navy/10" />
    ou
    <span className="h-px flex-1 bg-navy/10" />
  </div>
);

export const CheckRow = ({ id, checked, onChange, children, error }) => (
  <div>
    <label htmlFor={id} className="flex cursor-pointer items-start gap-3 text-sm leading-relaxed text-navy/80">
      <input
        id={id}
        type="checkbox"
        data-testid={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-5 w-5 shrink-0 cursor-pointer appearance-none rounded-md border border-navy/30 bg-white transition-colors duration-200 checked:border-navy checked:bg-navy checked:bg-[url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23E1C27A%22 stroke-width=%223%22><path d=%22M5 12l5 5L20 7%22/></svg>')] bg-center bg-no-repeat focus:outline-none focus:ring-4 focus:ring-gold/20"
      />
      <span>{children}</span>
    </label>
    {error && <p className="ml-8 mt-1 text-xs text-red-700" data-testid={`${id}-error`}>{error}</p>}
  </div>
);
